var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"ma-2"},[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),_c('v-card-text',[_vm._v(_vm._s(_vm.description))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }